/**
 * Issue brace, stamped to a standard that outlived the body that set it.
 */

import type { Affix } from '@/sim/items/affixContract';

export const REGULATION_BRACE = {
  id: 'regulationBrace',
  slot: 'prefix',
  field: 'recoil',
  direction: -1,
  label: 'Reduced recoil',
  nameWord: 'Regulation',
  ranges: {
    common: { min: 0.05, max: 0.1 },
    uncommon: { min: 0.1, max: 0.17 },
    rare: { min: 0.17, max: 0.26 },
    exotic: { min: 0.26, max: 0.38 },
  },
} as const satisfies Affix;
